import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { ProcedureFifteenService } from '../../services/procedures/procedure-fifteen.service';
import {environment} from '../../../environments/environment';
import {FilesService} from "../../services/files.service";

@Component({
  selector: 'ngx-procedure-fiveteen',
  templateUrl: './procedure-fiveteen.component.html',
  styleUrls: ['./procedure-fiveteen.component.scss'],
})
export class ProcedureFiveteenComponent implements OnInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  @Input() stationId: any;
  signaturePadOptions: Object;
  state = 'Actividades';
  file: any;
  token: any;

  responsableOptions = [
    {
      name: 'Responsable de la estación de servicio',
      value: 1,
    },
    {
      name: 'Área de mantenimiento',
      value: 2,
    },
    {
      name: 'Responsable Técnico',
      value: 3,
    },
    {
      name: 'Responsable Personal de Mantenimiento',
      value: 4,
    },
    {
      name: 'Encargado de la estación de servicio',
      value: 5,
    },
  ];

  attrAuxAudit = {
    loading: false,
    data: {
      date: new Date(),
      type: 'interno',
    },
    audits: [],
  };

  attrAuxAuditNoticeTeam = {
    loading: false,
    audits: [],
    data: {
      date: new Date(),
      name: '',
      role: 'Responsable de la estación de servicio',
      sign: '',
    },
  };

  attrAuxAuditPlan =  {
    audits: [],
    loading: false,
  };

  documents = {
    programAudits: '',
  };

  downloading = false;

  constructor(
    private procedureService: ProcedureFifteenService,
    private fileService: FilesService,
  ) { }

  async ngOnInit() {
    this.getAudits();
    this.getAuditsNoticeTeam();
    this.getAuditsPlan();
    const width = document.documentElement.clientWidth * .36;
    this.signaturePadOptions = {
      maxWidth: 1,
      'minWidth': 0.8,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
    this.getDocuments();
  }

  onChangeTab(event: any) {
    this.state = event.tabTitle;
  }

  loadImage(event: any) {
    if (!event.target.files.length) return;
    this.file = event.target.files[0];
  }

  async getAudits () {
    this.attrAuxAudit.loading = true;
    const [err, result]: any = await this.procedureService.getAudits(this.stationId);
    this.attrAuxAudit.loading = false;
    if (err) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    this.attrAuxAudit.audits = result.data;
  }

  async createAudit() {
    this.attrAuxAudit.loading = true;
    const [err, result] = await this.procedureService.createAudit(this.stationId, this.attrAuxAudit.data);
    this.attrAuxAudit.loading = false;
    if (err) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    console.error(result);
    await this.getAudits();
  }

  async getAuditsNoticeTeam () {
    this.attrAuxAuditNoticeTeam.loading = true;
    const [err, result]: any = await this.procedureService.getAuditsNoticeTeam(this.stationId);
    this.attrAuxAuditNoticeTeam.loading = false;
    if (err) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    this.attrAuxAuditNoticeTeam.audits = result.data;
  }

  async createAuditNoticeTeam() {
    this.attrAuxAuditNoticeTeam.loading = true;
    this.attrAuxAuditNoticeTeam.data.sign = this.signaturePad.toDataURL();
    const [error] = await this.procedureService.createAuditNoticeTeam(this.stationId, this.attrAuxAuditNoticeTeam.data);
    this.attrAuxAuditNoticeTeam.loading = false;
    if (error) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    this.alert('Programa de auditorias guardado con éxito');
    this.getAuditsNoticeTeam();
  }

  async getAuditsPlan () {
    this.attrAuxAuditPlan.loading = true;
    const [err, result]: any = await this.procedureService.getAuditsPlan(this.stationId);
    this.attrAuxAuditPlan.loading = false;
    if (err) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    this.attrAuxAuditPlan.audits = result.data;
  }

  async createAuditPlan() {
    this.attrAuxAuditPlan.loading = true;
    const data = new FormData();
    data.append('file', this.file);
    const [error] = await this.procedureService.createAuditPlan(this.stationId, data);
    this.attrAuxAuditPlan.loading = false;
    if (error) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    this.alert('Plan de auditorías cargado con éxito');
    this.getAuditsPlan();
  }

  generateUrlFo33(audit: any) {
    const url = `/filesGeneratorv2/implementation/15/audit/${audit.id}/notice/${this.stationId}`;
    const queryParams = `?date=${audit.date}`;
    const urlDownload = environment.baseEndpoint + url + queryParams;
    this.downloadFile(urlDownload, 'Auditoria ' + audit.name);
  }

  async getDocuments() {
    this.documents.programAudits = `${environment.baseEndpoint}/filesGeneratorv2/implementation/15/audit/${this.stationId}`;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }

}
